<script setup>
definePageMeta({
  middleware: ['require-verification', 'cookie-consent'],
});

</script>

<template>
  <div>
    <LegitimuzElements /> 
    <Play />
  </div>
</template>